import script from "./BannerC.vue?vue&type=script&lang=ts&setup=true"
export * from "./BannerC.vue?vue&type=script&lang=ts&setup=true"

import "./BannerC.vue?vue&type=style&index=0&id=0bb30136&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb30136"]])

export default __exports__